import app from '@/app';

/* @ngInject */
function UnifilarWorks($resource) {
	return $resource(
		'api/unifilarWorkss/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('UnifilarWorks', UnifilarWorks);
